<template >
    <div class="order">
        <div class="content">
            <img loading="lazy" src="../../assets/lives/d_ld.png" alt="" />
            <div class="content_text">
                <div v-for="(item, index) in 4" :key="index" style="margin: 4px;">
                    <span>毛毛{{ index }}</span>
                    <span>等3人</span>
                    <span>测试测试</span>
                </div>
            </div>
            <span @click="dialogFalg = true" class="content_btn">试试ss</span>
        </div>
        <div v-if="dialogFalg" class="dialog">
            <div class="dialog_detail">
                <div class="dialog_title">这是订单场控</div>
                <img src="../../assets/lives/csm_bg.png" alt="">
                <div @click="dialogFalg = false" class="dialog_btn">关闭</div>
            </div>
        </div>
    </div>
</template>

<script>
var interval
export default {
    name: "orderControl",
    data() {
        return {
            dialogFalg: false,
            scrollNum:0,
        }
    },

    mounted() {
        this.scroll()
    },

    methods: {
        scroll(){
            var contentText = document.getElementsByClassName('content_text')[0]
            interval = setInterval(() => {
                if(this.scrollNum > 4){
                    clearInterval(interval)
                    this.scrollNum = 0
                    return;
                }
                contentText.style.bottom = this.scrollNum * 21 + 'px'
                this.scrollNum++
            }, 2000)
        }
    },
}
</script>

<style scoped>
.order {
    text-align: left;

    .content {
        position: absolute;
        bottom: 13%;
        left: 2%;
        z-index: 999;
        max-width: 98%;
        background: #FFF2D0;
        color: #B46000;
        font-size: 13px;
        border-radius: 10px;
        padding: 4px 10px;
        opacity: 0.9;
        overflow: hidden;
        height: 24px;
        padding-right: 4px;
        display: flex;
        align-items: center;

        &>img {
            width: 16px;
            height: 16px;
        }

        &_text {
            display: inline-block;
            width: 200px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            align-self: flex-start;
            position: relative;
            bottom: 0;
            transition: top 0.5s linear;
        }

        &_btn {
            display: inline-block;
            background-color: rgb(247, 110, 42);
            color: rgb(250, 250, 250);
            padding: 2px 10px;
            border-radius: 10px;
            cursor: pointer;
        }
    }
}</style>